import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isNil} from 'lodash'
import BaseEditor from './baseEditor'
import Icon, {iconNames} from 'components/icon'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import {parseCssSelector} from 'helpers/css'

require('./inlineEditor.scss')

class ListEditor extends Component {

  focusMenu = () => {
    if (this.menuList) this.menuList.focus()
  }

  getMenuItem = (item) => {
    const {value, onCommit} = this.props
    const {key, label, icon} = item

    const checked = !isNil(value) && key === value
    const iconEl = icon
      ? <Icon name={icon}/>
      : <Icon name={iconNames.tick} style={checked ? null : {visibility: 'hidden'}}/>

    return (
      <MenuItem
        className={parseCssSelector(label)}
        key={key}
        value={key}
        onClick={() => onCommit(key)}
      >
        <ListItemIcon>{iconEl}</ListItemIcon>
        {label}
      </MenuItem>
    )
  }

  sortValues = (a, b) => {
    if (a.label > b.label) return 1
    if (a.label < b.label) return -1
    return 0
  }

  render() {
    let {values} = this.props
    const {open, anchor, value, allowNone, noneOption, onCommit, onCancel, ...otherProps} = this.props
    let height = 16 + (values.length * 48)

    values = [...values]
    values.sort(this.sortValues)

    let noneEl
    if (allowNone) {
      height += 48

      noneEl = (
        <MenuItem
          key={'_'}
          value={null}
          onClick={() => onCommit(null)}
        >
          <ListItemIcon>
            <Icon name={iconNames.tick} style={isNil(value) ? null : {visibility: 'hidden'}}/>
          </ListItemIcon>
          {noneOption}
        </MenuItem>
      )
    }

    return (
      <BaseEditor
        open={open}
        anchor={anchor}
        {...otherProps}
        height={height}
        onClose={onCancel}
        onEntered={this.focusMenu}
        padded={false}
      >
        <MenuList
          className={'list-editor-menu'}
          ref={e => {
            this.menuList = e
          }}
        >
          {noneEl}
          {values.map(v => this.getMenuItem(v))}
        </MenuList>
      </BaseEditor>
    )
  }
}

ListEditor.propTypes = {
  value: propTypes.any, // to match values[].key
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  values: propTypes.arrayOf(propTypes.shape({
    key: propTypes.any.isRequired,
    label: propTypes.string.isRequired,
  })).isRequired,
  allowNone: propTypes.bool,
  noneOption: propTypes.string,
  onCommit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
}

ListEditor.defaultProps = {
  allowNone: true,
  noneOption: 'None',
}

export default ListEditor
